import React from "react";
import Modal from "react-modal";
import { Client, SwitcherProps } from "shared/Switcher/types";
import { useAppDispatch, useAppSelector } from "appHooks";
import { setClient } from "features/client/client.reducer";
import { setSlug } from "features/config/config.reducer";
import { clientSelector } from "features/client/client.selectors";
import { configSelector } from "features/config/config.selectors";
import { useRouter } from "next/navigation";

const Switcher: React.FC<SwitcherProps> = ({ open, onClose, clients }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { data: clientData } = useAppSelector(clientSelector);
  const { locale } = useAppSelector(configSelector);
  const id = clientData.id;
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    setIsMobile(window.innerWidth <= 992);
  }, []);

  const customStyles: Modal.Styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1001,
    },
    content: {
      position: "absolute",
      height: "fit-content",
      width: isMobile ? "86%" : "fit-content",
      top: isMobile ? "2%" : "10%",
      bottom: isMobile ? "2%" : "10%",
      left: isMobile ? "2%" : "30%",
      right: isMobile ? "2%" : "30%",
      borderColor: "#121313",
      background: "#121313",
      overflow: "hidden",
      WebkitOverflowScrolling: "touch",
      borderRadius: "12px",
      outline: "none",
      padding: "20px",
    },
  };

  const onClientClick = (client: Client) => {
    dispatch(setClient(client as any));
    dispatch(setSlug(client.slug));
    onClose();
    router.replace(`/${locale}`);
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={onClose}
        ariaHideApp={false}
        style={customStyles}
      >
        <div className="menu-block">
          <i
            className="cross-icon"
            style={{
              display: "block",
              marginLeft: "auto",
              cursor: "pointer",
              marginBottom: "10px",
            }}
            onClick={onClose}
          ></i>
        </div>

        <div className="grid-container">
          {clients?.map((client) => (
            <div
              key={client.id}
              className={`grid-item ${
                client.id === id ? "selected-grid-item" : ""
              }`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => onClientClick(client)}
            >
              {client.logo && (
                <img
                  src={client.logo}
                  alt="gallery"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default Switcher;
